import { render, staticRenderFns } from "./sku-list.vue?vue&type=template&id=a8bceb48&scoped=true"
import script from "./sku-list.vue?vue&type=script&lang=ts"
export * from "./sku-list.vue?vue&type=script&lang=ts"
import style0 from "./sku-list.vue?vue&type=style&index=0&id=a8bceb48&prod&lang=less&scoped=true"
import style1 from "./sku-list.vue?vue&type=style&index=1&id=a8bceb48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bceb48",
  null
  
)

export default component.exports